module.exports = __webpack_public_path__ + "assets/empty-time.4fe89c0c.svg";